<template>
  <div ref="formulario">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group has-label">
          <label
            class="text-transform-none"
            style="color: #005d2c; font-size: 18px"
            >{{ dictionary.label_1 }}</label
          >
          <fg-input
            id="farm_name"
            type="text"
            name="farm_name"
            v-model="model.farm_name"
            :placeholder="dictionary.placeholder_1"
          ></fg-input>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group has-label">
          <label
            class="text-transform-none"
            style="color: #005d2c; font-size: 18px"
            >{{ dictionary.label_2 }}</label
          >
          <el-select
            id="crops"
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            v-model="model.crop"
            :placeholder="dictionary.placeholder_2"
            filterable
          >
            <el-option
              v-for="option in crops"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <label
          class="text-transform-none"
          style="color: #005d2c; font-size: 18px"
          >{{ dictionary.text_1 }}</label
        >
        <label style="color: rgb(147 147 146); font-size: 13px">
          {{ dictionary.text_2 }}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <fg-input
          id="latitude"
          type="text"
          name="latitud"
          :label="dictionary.label_3"
          @change="validateNumber"
          v-model="model.latitude"
          v-validate="'decimal'"
          :error="getError('latitud')"
          v-on:change="geoMap"
          :placeholder="dictionary.placeholder_3"
        ></fg-input>
      </div>
      <div class="col-md">
        <fg-input
          id="longitude"
          type="text"
          name="longitud"
          :label="dictionary.label_4"
          @change="validateNumber"
          v-model="model.longitude"
          v-validate="'decimal'"
          :error="getError('longitud')"
          v-on:change="geoMap"
          :placeholder="dictionary.placeholder_4"
        ></fg-input>
      </div>
      <!--<div class="col-md-4">
          <fg-input
            id="altitude"
            type="text"
            name="altitud"
            :label="dictionary.label_5"
            @change="validateNumber"
            v-model="model.altitude"
            v-validate="'decimal'"
            :error="getError('altitud')"
          ></fg-input>
      </div>-->
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group has-label mt-4">
          <div
            ref="map"
            class="map"
            v-if="renderComponent"
            style="height: 500px"
          ></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinTranslate from 'src/util/mixinTranslate';
import { MixinExport } from 'src/mixins/mixin-export';

export default {
  props: {
    crops: {
      type: Array,
      required: true,
    },
    farms: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      model: {
        crop: null,
        latitude: null,
        longitude: null,
        altitude: 0,
        farm_name: null,
      },
      globalDictionary: {},
      dictionary: {
        label_1: null,
        label_2: null,
        label_3: null,
        label_4: null,
        label_5: null,
        placeholder_1: null,
        placeholder_2: null,
        placeholder_3: null,
        placeholder_4: null,
        text_1: null,
        text_2: null,
      },
      renderComponent: true,
    };
  },
  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    MixinMasters,
    MixinExport,
    MixinTranslate,
  ],
  methods: {
    En() {
      this.dictionary = this.translateEn()['firstStep'];
      this.globalDictionary = this.translateEn();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },
    Es() {
      this.dictionary = this.translateEs()['firstStep'];
      this.globalDictionary = this.translateEs();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    validateNumber($text) {
      let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
      if ($text.target.value.match(regex) == null) {
        switch ($text.target.name) {
          case 'latitud':
            this.model.latitude = null;
            break;

          case 'longitud':
            this.model.longitude = null;
            break;

          /*case 'altitud':
            this.model.altitude = null;
            break;
          */
          default:
            break;
        }
      } else {
        //$text.target.classList.remove("custom-has-error");
      }
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    geoMap($event) {
      if ($event != undefined) {
        let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
        if ($event.target.value.match(regex) == null) {
          switch ($event.target.classList) {
            case 'latitud':
              this.model.latitude = null;
              break;

            case 'longitud':
              this.model.longitude = null;
              break;

            /*case 'altitud':
              this.model.altitude = null;
              break;
            */
            default:
              break;
          }
        } else {
          // $event.target.classList.remove("custom-has-error");
        }
      }

      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;
      this.loadMap();
    },

    loadMap() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapRegistrationForm();
        this.showHideLoading();

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 23%;right: 30px';
        }, 10);
      });
    },
    customError(ref) {
      document.getElementById(ref).classList.add('custom-has-error');
      setTimeout(() => {
        document.getElementById(ref).classList.remove('custom-has-error');
      }, 4000);
    },
    validated() {
      return this.$validator.validateAll().then((res) => {
        let band = true;
        if (this.model.farm_name * 1 == 0 || this.model.farm_name == null) {
          this.customError('farm_name');
          band = false;
        }
        if (this.model.crop * 1 == 0 || this.model.crop == null) {
          this.customError('crops');
          band = false;
        }
        if (this.model.latitude * 1 == 0 || this.model.latitude == null) {
          this.customError('latitude');
          band = false;
        }
        if (this.model.longitude * 1 == 0 || this.model.longitude == null) {
          this.customError('longitude');
          band = false;
        }
        /*if (this.model.altitude * 1 == 0 || this.model.altitude == null) {
          this.customError('altitude');
          band = false;
        }
        if (this.model.altitude * 1 == 0 || this.model.altitude == null) {
          this.customError('altitude');
          band = false;
        }*/
        if (band) {
          this.$emit('on-validated', res, this.model);
        }
        return band;
      });
    },
  },

  created() {
    if (sessionStorage.getItem('globalDictionary')) {
      this.dictionary = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).firstStep;
    } else {
      this.Es();
    }
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading();
    }
  },

  mounted() {
    this.geoMap();
  },

  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
